import { network } from 'services/network';

export const getAiResourcesMitigation = (params) => {
    return network.post('api/bo/chat/getAiResourcesMitigation', params).then((response) => {
        return response.data;
    });
};
